import {combineEpics} from 'web-app/util/redux-observable';

import mealTypes from './meals/meal-plan/epics';
import foodConsumption from './meals/food-consumption/epics';
import feedItems from './feed/items/epics';
import drafts from './drafts/epics';
import recipients from './recipients/epics';
import recurringPayments from './recurring-payments/epics';
import productsEpics from './products/epics';
import sessionsEpics from './sessions/epics';
import contactEpics from './contacts/epics';
import childrenEpics from './children/epics';
import discountEpics from './discounts/epics';
import paymentMethodEpics from './payment-methods/epics';
import organizationPersons from './organization-persons/epics';
import depositEpics from './deposits/epics';
import accountItemEpics from './account-items/epics';
import institutionEpics from './institutions/epics';
import areaEpics from './areas/epics';
import organizationEpics from './organizations/epics';
import groupEpics from './groups/epics';
import billPayerEpics from './bill-payers/epics';
import creditEpics from './credits/epics';
import surchargeEpics from './surcharges/epics';
import plansEpics from './plans/epics';
import employeesEpics from './employees/epics';
import tagsEpics from './tags/epics';
import accidentIncidentReportEpics from './accident-incident-reports/epics';
import statusEpics from './statuses/epics';
import reportLocationEpics from './report-locations/epics';

export default combineEpics(
    statusEpics,
    mealTypes,
    foodConsumption,
    feedItems,
    drafts,
    recipients,
    recurringPayments,
    productsEpics,
    sessionsEpics,
    contactEpics,
    childrenEpics,
    discountEpics,
    groupEpics,
    paymentMethodEpics,
    organizationPersons,
    depositEpics,
    accountItemEpics,
    institutionEpics,
    areaEpics,
    organizationEpics,
    billPayerEpics,
    creditEpics,
    surchargeEpics,
    plansEpics,
    employeesEpics,
    tagsEpics,
    accidentIncidentReportEpics,
    reportLocationEpics,
);
